import { Fraction } from 'bi-fraction';
import { CRO_DECIMALS_ON_ETHEREUM } from '../config/constants';
import { ChainLayer, } from '../types';
import { executeTx, getProvider } from '../utils';
const ETH_DECIMALS = 18;
/** gas fees to approve token spending */
const FEES_FOR_APPROVE = 46589n;
/** gas fees for early support deposit function execution */
const FEES_FOR_DEPOSIT = 175262n;
export class PrelaunchDepositEthereum {
    constructor(contract, wcro, providerOptions) {
        this.contract = contract;
        this.wcro = wcro;
        this.providerOptions = providerOptions;
    }
    async depositCro(owner, amount) {
        const allowance = await this.wcro.allowance(owner, this.contract.getAddress());
        const amountBigInt = amount.shl(CRO_DECIMALS_ON_ETHEREUM).quotient;
        if (allowance < amountBigInt) {
            const tx = this.wcro.approve(this.contract.getAddress(), amountBigInt);
            await executeTx(tx);
        }
        return this.contract.deposit(amountBigInt);
    }
    /**
     * Returns an estimate of the gas to be spent for early depositing (and possibly approving first) CRO tokens
     *
     * @param owner address of depositor
     * @param amount amount to be deposited
     * @returns estimated gas fee in ETH
     */
    async estimateGasDepositCro(owner, amount) {
        const amountBigInt = amount.shl(CRO_DECIMALS_ON_ETHEREUM).quotient;
        const [allowance, { gasPrice }] = await Promise.all([
            this.wcro.allowance(owner, this.contract.getAddress()),
            getProvider(this.providerOptions, ChainLayer.L1).getFeeData(),
        ]);
        if (!gasPrice)
            return null;
        // these values need to be hardcoded because we cannot auto-estimate gas of deposit if approval is missing
        // we have to update it in case SC changes
        const resultBigInt = (FEES_FOR_DEPOSIT + (allowance < amountBigInt ? FEES_FOR_APPROVE : 0n)) *
            gasPrice;
        return new Fraction(resultBigInt).shr(ETH_DECIMALS);
    }
}
